// Spiegeln eines Teils über die Querachse (links ↔ rechts entlang der Länge):
// „Seitenwand links“ → „Seitenwand rechts“. Maße, Position und Rotation bleiben,
// alle Bearbeitungen wandern auf die gespiegelte Seite. Engine-frei.
import { cutoutsOf, cutoutAxis } from "./cutouts"
import { cornersOf } from "./corners"
import { EDGE_KEYS, edgesOf } from "./edges"
import { groovesOf, isFalz } from "./machinings"
import { mitersOf } from "./miters"

const CORNER_SWAP = { vl: "vr", vr: "vl", hl: "hr", hr: "hl" }
const EDGE_SWAP = { b1: "b2", b2: "b1", l1: "l1", l2: "l2" }

export function mirroredMeta(part) {
  const meta = { ...part.meta }

  const cutouts = cutoutsOf(part)
  if (cutouts.length > 0) {
    // Stirnbohrung längs (axis "x"): die Bohrachse selbst wird gespiegelt —
    // aus der rechten Stirn wird die linke, die Querlage bleibt.
    meta.cutouts = cutouts.map((cutout) => cutoutAxis(cutout) === "x"
      ? { ...cutout, side: cutout.side === "bottom" ? "top" : "bottom" }
      : { ...cutout, x_mm: -cutout.x_mm })
  }

  const corners = cornersOf(part)
  if (Object.keys(corners).length > 0) {
    meta.corners = Object.fromEntries(
      Object.entries(corners).map(([key, treatment]) => [CORNER_SWAP[key], { ...treatment }])
    )
  }

  const edges = edgesOf(part)
  if (edges.length > 0) {
    meta.edges = EDGE_KEYS.filter((key) => edges.includes(EDGE_SWAP[key]))
  }

  const grooves = groovesOf(part)
  if (grooves.length > 0) {
    meta.grooves = grooves.map((groove) => {
      if (isFalz(groove)) return { ...groove, edge: EDGE_SWAP[groove.edge] }
      if (groove.direction === "z") {
        // Offset ab linker Kante → spiegelt auf die rechte Seite
        return { ...groove, offset_mm: part.length_mm - groove.offset_mm }
      }
      return { ...groove } // Längsnut: Abstand ab vorderer Kante bleibt
    })
  }

  const miters = mitersOf(part)
  if (miters.length > 0) {
    meta.miters = miters.map((miter) => ({ ...miter, edge: EDGE_SWAP[miter.edge] }))
  }

  if (Array.isArray(meta.outline)) {
    meta.outline = [ ...meta.outline ].reverse().map(([ x, z ]) => [ -x, z ])
  }

  return meta
}
